import { createFileRoute } from '@tanstack/react-router';

/**
 * Potenciais Investidores (RI, Bloco 2 / Fatia A — ADR-0013). Lista + ficha de investidores.
 * Componente vem de ri.investidores.lazy.tsx (code-splitting por rota, D4/DEC-060).
 */
export const Route = createFileRoute('/ri/investidores')({});
